import { Component, EventEmitter, HostListener, inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { DevolutionDetailModel } from 'src/app/models/rental/devolution-detail.model';
import { DevolutionModel } from 'src/app/models/rental/devolution.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { RentalStockModalModel } from 'src/app/models/tables/rental/rental-stock-modal.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { GeneralParameterService } from 'src/app/services/management/general-parameter.service';
import { DevolutionDetailService } from 'src/app/services/rental/devolution-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-devolution-detail',
  templateUrl: './register-devolution-detail.component.html',
  styleUrls: ['./register-devolution-detail.component.scss'],
  standalone: false
})
export class RegisterDevolutionDetailComponent implements OnInit, OnChanges, OnDestroy {


  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;

  @Input() devolutionModel: DevolutionModel = new DevolutionModel();
  @Input() devolutionDetailContract: DevolutionDetailModel = new DevolutionDetailModel();
  @Input() isFormViewOpen: boolean = false;
  @Output() isFormView = new EventEmitter<boolean>();
  @Output() updateListDetail = new EventEmitter<boolean>();

  articleId: number = 0;
  ascendantArticle: boolean = true;
  codeNameArticle: string = '';
  columnSortArticle: string | null = null;
  dataArticle: PagedResponseModel<RentalStockModalModel> = new PagedResponseModel<RentalStockModalModel>();
  devolutionDetailId: number = 0;
  filtersArticle: ColumnResponseModel[] = [];
  formDevolutionDetail: FormGroup = new FormGroup({});
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
  });
  limitArticle: number = 10000;
  output$ = new Subject<any>();
  pageArticle: number = 1;
  rentalStockArticle: number = 0;
  rentalStockForm: number = 0;
  subscription: Subscription;
  swDirectDevolutionWorkshop: boolean = false;
  swEquipmentLogbook: boolean = false;
  swHabilitarLimpiezaEnDevoluciones: boolean = false;
  componentTableSelection = CustomTableSelectComponent;

  private readonly articleService = inject(ArticleService);
  private readonly devolutionDetailService = inject(DevolutionDetailService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly formControlStateService = inject(FormControlStateService);
  private readonly generalParameterService = inject(GeneralParameterService);
  private readonly toastHandlerService = inject(ToastHandlerService);

  constructor() {
    this.validateForm(this.devolutionDetailContract);
  }

  async ngOnInit() {
    await this.getGeneralParametersByCompany();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }
  async ngOnChanges(changes: SimpleChanges) {
    const devolutionDetailContract = changes['devolutionDetailContract'];
    const isFormViewOpen = changes['isFormViewOpen'];
    if (devolutionDetailContract) {
      if (this.devolutionModel.devolutionId !== 0) {
        await this.getArticlesForDevolutionDetail();
      }
      if (this.devolutionDetailContract.devolutionDetailId === 0) {
        this.devolutionDetailId = 0;
        this.codeNameArticle = '';
        this.rentalStockArticle = 0;
        this.devolutionDetailContract = new DevolutionDetailModel();
        if (isFormViewOpen && !isFormViewOpen.firstChange) {
          this.openArticleSelectionModal();
        }
      } else {
        this.getArticle(this.devolutionDetailContract.articleId);
        this.devolutionDetailId = this.devolutionDetailContract.devolutionDetailId;
        this.rentalStockArticle = this.dataArticle.items.find(
          item => item.articleId === this.devolutionDetailContract.articleId && item.storeId === this.devolutionDetailContract.storeId
        )?.stock || 0;
      }
      this.validateForm(this.devolutionDetailContract);
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  async areThereBalancesInCostCenter() {
    try {
      const response = await firstValueFrom(this.devolutionDetailService.areThereBalancesInCostCenter(this.devolutionModel.branchId, this.devolutionModel.costCenterId))
      if (!response) {
        this.toastHandlerService.showToast('info', 'El centro de costos ya no tiene saldos.');
      }
    } catch (error) {
      console.error('Error al validar los saldos del c.costos.', error);
    }
  }

  // changePredevolutionQuantity(predevolutionQuantity: number) {
  //   if (predevolutionQuantity < 0) {
  //     this.toastHandlerService.showToast(
  //       'error',
  //       'La cantidad de predevolución no puede ser negativa.'
  //     );
  //     setTimeout(() => this.formDevolutionDetail.get('predevolutionQuantity')?.patchValue(this.devolutionDetailContract.predevolutionQuantity), 100);
  //     return;
  //   }
  //   if (predevolutionQuantity > this.rentalStockArticle) {
  //     this.toastHandlerService.showToast(
  //       'error',
  //       'La cantidad de predevolución no puede ser mayor a la existencia.'
  //     );
  //     setTimeout(() => this.formDevolutionDetail.get('predevolutionQuantity')?.patchValue(this.devolutionDetailContract.predevolutionQuantity), 100);
  //     return;
  //   }
  // }

  // async changeQuantity(quantity: number) {
  //   const cleaningQuantity = this.formDevolutionDetail.get('cleaningQuantity')?.value || 0;
  //   const repairQuantity = this.formDevolutionDetail.get('repairQuantity')?.value || 0;
  //   const replacementQuantity = this.formDevolutionDetail.get('replacementQuantity')?.value || 0;
  //   if (quantity < 0) {
  //     this.toastHandlerService.showToast('error', 'La cantidad no puede ser negativa.');
  //     this.rentalStockForm = this.rentalStockArticle + this.devolutionDetailContract.quantity +
  //       this.devolutionDetailContract.replacementQuantity - replacementQuantity +
  //       this.devolutionDetailContract.cleaningQuantity - cleaningQuantity +
  //       this.devolutionDetailContract.repairQuantity - repairQuantity;
  //     setTimeout(() => this.formDevolutionDetail.get('quantity')?.patchValue(this.devolutionDetailContract.quantity), 100);
  //     return;
  //   }
  //   if (this.devolutionDetailContract.devolutionDetailId === 0) {
  //     if (quantity > (this.rentalStockArticle - replacementQuantity + cleaningQuantity + repairQuantity)) {
  //       this.toastHandlerService.showToast('error', 'Las cantidades de devolución no pueden ser mayor a la existencia.');
  //       this.rentalStockForm = this.rentalStockArticle + this.devolutionDetailContract.quantity +
  //         this.devolutionDetailContract.replacementQuantity - replacementQuantity +
  //         this.devolutionDetailContract.cleaningQuantity - cleaningQuantity +
  //         this.devolutionDetailContract.repairQuantity - repairQuantity;
  //       setTimeout(() => this.formDevolutionDetail.get('quantity')?.patchValue(this.devolutionDetailContract.quantity), 100);
  //       return;
  //     }
  //     this.rentalStockForm = this.rentalStockArticle - quantity - cleaningQuantity - repairQuantity - replacementQuantity;
  //   } else {
  //     if (quantity > (this.rentalStockArticle + this.devolutionDetailContract.quantity +
  //       this.devolutionDetailContract.replacementQuantity - replacementQuantity +
  //       this.devolutionDetailContract.cleaningQuantity - cleaningQuantity +
  //       this.devolutionDetailContract.repairQuantity - repairQuantity)) {
  //       this.toastHandlerService.showToast('error', 'Las cantidades de devolución no pueden ser mayor a la existencia.');
  //       this.rentalStockForm = this.rentalStockArticle + this.devolutionDetailContract.quantity +
  //         this.devolutionDetailContract.replacementQuantity - replacementQuantity +
  //         this.devolutionDetailContract.cleaningQuantity - cleaningQuantity +
  //         this.devolutionDetailContract.repairQuantity - repairQuantity;
  //       setTimeout(() => this.formDevolutionDetail.get('quantity')?.patchValue(0), 100);
  //       return;
  //     }
  //     this.rentalStockForm = this.rentalStockArticle + this.devolutionDetailContract.quantity - quantity +
  //       this.devolutionDetailContract.replacementQuantity - replacementQuantity +
  //       this.devolutionDetailContract.cleaningQuantity - cleaningQuantity +
  //       this.devolutionDetailContract.repairQuantity - repairQuantity;
  //   }
  // }

  // async changeReplacementQuantity(replacementQuantity: number) {
  //   const quantity = this.formDevolutionDetail.get('quantity')!.value || 0;
  //   if (replacementQuantity < 0) {
  //     this.toastHandlerService.showToast(
  //       'error',
  //       'La cantidad faltante no puede ser negativa.'
  //     );
  //     this.rentalStockForm = this.rentalStockArticle + this.devolutionDetailContract.quantity +
  //       this.devolutionDetailContract.replacementQuantity - quantity;
  //     setTimeout(() => this.formDevolutionDetail.get('replacementQuantity')?.patchValue(this.devolutionDetailContract.replacementQuantity), 100);
  //     return;
  //   }

  //   if (this.devolutionDetailContract.devolutionDetailId === 0) {
  //     if (replacementQuantity > (this.rentalStockArticle - quantity)) {
  //       this.toastHandlerService.showToast(
  //         'error',
  //         quantity === 0 ? 'La cantidad de faltantes no puede ser mayor a la existencia.' :
  //           'La cantidad de faltantes no puede ser mayor al saldo entre la existencia y la cantidad devuelta.'
  //       );
  //       this.rentalStockForm = this.rentalStockArticle + this.devolutionDetailContract.quantity +
  //         this.devolutionDetailContract.replacementQuantity - quantity;
  //       setTimeout(() => this.formDevolutionDetail.get('replacementQuantity')?.patchValue(this.devolutionDetailContract.replacementQuantity), 100);
  //       return;
  //     }
  //     this.rentalStockForm = this.rentalStockArticle - replacementQuantity - quantity;
  //   } else {
  //     if (replacementQuantity > (this.rentalStockArticle + this.devolutionDetailContract.quantity +
  //       this.devolutionDetailContract.replacementQuantity - quantity)) {
  //       this.toastHandlerService.showToast(
  //         'error',
  //         quantity === 0 ? 'La cantidad de faltantes no puede ser mayor a la existencia.' :
  //           'La cantidad de faltantes no puede ser mayor al saldo entre la existencia y la cantidad devuelta.'
  //       );
  //       this.rentalStockForm = this.rentalStockArticle + this.devolutionDetailContract.quantity +
  //         this.devolutionDetailContract.replacementQuantity - quantity;
  //       setTimeout(() => this.formDevolutionDetail.get('replacementQuantity')?.patchValue(0), 100);
  //       return;
  //     }
  //     this.rentalStockForm = this.rentalStockArticle + this.devolutionDetailContract.replacementQuantity +
  //       this.devolutionDetailContract.quantity - replacementQuantity - quantity;
  //   }

  //   if (this.devolutionDetailContract.replacementValue === 0) {
  //     if (replacementQuantity !== 0) {
  //       try {
  //         const article = await firstValueFrom(this.articleService.getArticleById(this.devolutionDetailContract.articleId));
  //         const replacementValue = (replacementQuantity * article.replacementValue).toFixed(2) as unknown as number;
  //         if (article.replacementValue === 0) {
  //           const replacementUnitValue = this.formDevolutionDetail.get('replacementUnitValue')!.value || 0;
  //           setTimeout(() => this.formDevolutionDetail.get('replacementValue')?.patchValue(replacementQuantity * replacementUnitValue), 100);
  //         } else {
  //           setTimeout(() => this.formDevolutionDetail.get('replacementValue')?.patchValue(replacementValue), 100);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching article for replacement value:", error);
  //       }
  //     } else {
  //       const replacementUnitValue = this.formDevolutionDetail.get('replacementUnitValue')!.value || 0;
  //       setTimeout(() => this.formDevolutionDetail.get('replacementValue')?.patchValue(replacementQuantity * replacementUnitValue), 100);
  //     }
  //   } else {
  //     if (replacementQuantity === 0) {
  //       setTimeout(() => this.formDevolutionDetail.get('replacementValue')?.patchValue(0), 100);
  //     }
  //   }
  // }

  async changeCleaningQuantity(cleaningQuantity: number) {
    if (cleaningQuantity < 0) {
      this.toastHandlerService.showToast('error', 'La cantidad de limpieza no puede ser negativa.');
      return;
    }

    if (cleaningQuantity === 0) {
      setTimeout(() => this.formDevolutionDetail.get('cleaningValue')?.patchValue(0), 100);
      return;
    }

    try {
      const cleaningValue = await firstValueFrom(this.articleService.getCleaningValueByArticleId(this.articleId));
      setTimeout(() => this.formDevolutionDetail.get('cleaningValue')?.patchValue(cleaningValue * cleaningQuantity), 100);
    } catch (error) {
      console.error('Error al buscar el valor de limpieza', error);
    }
  }

  async changeRepairQuantity(repairQuantity: number) {
    if (repairQuantity < 0) {
      this.toastHandlerService.showToast('error', 'La cantidad de reparación no puede ser negativa.');
      return;
    }

    if (!this.devolutionDetailContract.hasRepairs) {
      if (repairQuantity === 0) {
        setTimeout(() => this.formDevolutionDetail.get('repairValue')?.patchValue(0), 100);
        return;
      }
      try {
        const repairValue = await firstValueFrom(this.articleService.getRepairValueByArticleId(this.articleId));
        setTimeout(() => this.formDevolutionDetail.get('repairValue')?.patchValue(repairValue * repairQuantity), 100);
      } catch (error) {
        console.error('Error al buscar el valor de reparación', error);
      }
    }
  }

  async changeReplacementQuantity(replacementQuantity: number) {
    if (replacementQuantity < 0) {
      this.toastHandlerService.showToast('error', 'La cantidad de faltante no puede ser negativa.');
      return;
    }

    if (replacementQuantity === 0) {
      setTimeout(() => {
        this.formDevolutionDetail.get('replacementUnitValue')?.patchValue(0);
        this.formDevolutionDetail.get('replacementValue')?.patchValue(0);
      }, 100);
      return;
    }

    try {
      const replacementValue = await firstValueFrom(this.articleService.getReplacementValueByArticleId(this.articleId));
      setTimeout(() => {
        this.formDevolutionDetail.get('replacementUnitValue')?.patchValue(replacementValue);
        this.formDevolutionDetail.get('replacementValue')?.patchValue(replacementValue * replacementQuantity);
      }, 100);
    } catch (error) {
      console.error('Error al buscar el valor de faltante', error);
    }
  }

  changeReplacementTotalValue(replacementTotalValue: number) {
    if (replacementTotalValue < 0) {
      this.toastHandlerService.showToast('error', 'El valor total de faltantes no puede ser negativo.');
      return;
    }
    const replacementQuantity = this.formDevolutionDetail.get('replacementQuantity')!.value || 0;
    if (replacementQuantity === 0) {
      setTimeout(() => this.formDevolutionDetail.get('replacementUnitValue')?.patchValue(0), 100);
    } else {
      const replacementUnitValue = (replacementTotalValue / replacementQuantity).toFixed(2) as unknown as number;
      setTimeout(() => this.formDevolutionDetail.get('replacementUnitValue')?.patchValue(replacementUnitValue), 100);
    }
  }

  changeReplacementUnitValue(replacementUnitValue: number) {
    if (replacementUnitValue < 0) {
      this.toastHandlerService.showToast(
        'error',
        'El valor unitario del faltante no puede ser negativo.'
      );
      return;
    }

    const replacementQuantity = this.formDevolutionDetail.get('replacementQuantity')!.value || 0;
    const replacementValue = (replacementQuantity * replacementUnitValue).toFixed(2) as unknown as number;
    setTimeout(() => this.formDevolutionDetail.get('replacementValue')?.patchValue(replacementValue), 100);
  }

  clearForm() {
    this.devolutionDetailId = 0;
    this.codeNameArticle = '';
    this.rentalStockArticle = 0;
    this.devolutionDetailContract = new DevolutionDetailModel();
    this.validateForm(this.devolutionDetailContract);
    this.isFormView.emit(false);
  }

  async getArticle(articleId: number | null) {
    if (articleId != null && articleId != 0) {
      const article = await firstValueFrom(this.articleService.getArticleById(articleId));
      if (article) {
        this.articleId = articleId;
        this.codeNameArticle = `${article.code} - ${article.name}`;
        this.swDirectDevolutionWorkshop = article.swDirectDevolutionWorkshop;
        this.swEquipmentLogbook = article.swEquipmentLogbook;
      } else {
        this.codeNameArticle = 'Error al buscar el elemento. Por favor refresque la página.';
        return;
      }
    } else {
      this.articleId = 0;
      this.codeNameArticle = '';
    }
  }

  async getArticlesForDevolutionDetail() {
    try {
      this.dataArticle = await firstValueFrom(
        this.devolutionDetailService.getArticlesForDetailsAsync(
          this.devolutionModel.branchId,
          this.devolutionModel.costCenterId,
          this.devolutionModel.rentalPeriodId,
          this.pageArticle,
          this.limitArticle,
          this.columnSortArticle,
          this.ascendantArticle,
          this.filtersArticle
        )
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getColumnsArticle() {
    try {
      if (this.headerArticle.length === 0) {
        this.headerArticle = await firstValueFrom(
          this.devolutionDetailService.getColumnsForArticles()
        );
      }
    } catch (error) {
      console.error(
        'Error to get columns for articles.',
        error
      );
    }
  }

  async getDevolutionDetailByKeys(articleId: number, storeId: number) {
    try {
      this.devolutionDetailContract = await firstValueFrom(
        this.devolutionDetailService.getDevolutionDetailByKeys(this.devolutionModel.devolutionId, articleId, storeId)
      );
      this.validateForm(this.devolutionDetailContract);
      this.devolutionDetailId = this.devolutionDetailContract.devolutionDetailId;
      if (this.devolutionDetailId === 0) {
        if (this.devolutionModel.isPredevolution) {
          setTimeout(() => this.formDevolutionDetail.get('predevolutionQuantity')?.patchValue(this.rentalStockArticle), 100);
        } else {
          if (this.swDirectDevolutionWorkshop && !this.swEquipmentLogbook && this.swHabilitarLimpiezaEnDevoluciones) {
            setTimeout(() => this.formDevolutionDetail.get('cleaningQuantity')?.patchValue(this.rentalStockArticle), 100);
            this.changeCleaningQuantity(this.rentalStockArticle);
          } else if (this.swDirectDevolutionWorkshop && this.swEquipmentLogbook) {
            setTimeout(() => this.formDevolutionDetail.get('repairQuantity')?.patchValue(this.rentalStockArticle), 100);
            this.changeRepairQuantity(this.rentalStockArticle);
          } else {
            setTimeout(() => this.formDevolutionDetail.get('quantity')?.patchValue(this.rentalStockArticle), 100);
          }
        }
      }
    } catch (error) {
      console.error('Error fetching devolution detail by keys.', error);
    }
  }

  async getGeneralParametersByCompany() {
    try {
      const generalParameters = await firstValueFrom(this.generalParameterService.getGeneralParametersByUserAutheticated());
      this.swHabilitarLimpiezaEnDevoluciones = generalParameters.some(x => x.generalParameterId === GeneralParameterEnums.habilitarLimpiezaEnDevoluciones);
    } catch (error) {
      console.error('Error al buscar las ventanas del usuario autenticado.', error);
    }
  }

  async handleSelectedItem(selectedItem: any) {
    if (selectedItem && selectedItem.length === 1) {
      this.isFormView.emit(true);
      const articleId = parseInt(selectedItem[0]?.articleId);
      await this.getArticle(articleId);
      this.rentalStockArticle = this.dataArticle.items.find(item => item.articleId === articleId && item.storeId === selectedItem[0]!.storeId)?.stock || 0;
      await this.getDevolutionDetailByKeys(articleId, selectedItem[0]!.storeId);
    }
    if (selectedItem && selectedItem.length > 1) {
      if (this.devolutionModel.isPredevolution) {
        for (const item of selectedItem) {
          item.predevolutionQuantity = item.stock;
          await firstValueFrom(this.devolutionDetailService.savePredevolutionDetails(item, this.devolutionModel.devolutionId));
        }
      } else {
        await firstValueFrom(this.devolutionDetailService.createSomeDetails(selectedItem, this.devolutionModel.devolutionId));
        await this.areThereBalancesInCostCenter();
      }
      this.getArticlesForDevolutionDetail();
      this.clearForm();
      this.updateListDetail.emit(true);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChangeArticle(event: {
    page: number;
    pageSize: number;
    sortField: string | undefined;
    sortOrder: number;
  }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    this.getArticlesForDevolutionDetail();
  }

  async openArticleSelectionModal() {
    this.filtersArticle = [];
    await Promise.all([
      await this.getColumnsArticle(),
      this.getArticlesForDevolutionDetail(),
    ]);
    this.updateInputs();

    if (this.articleSelectionModalComponent && this.headerArticle) {
      this.articleSelectionModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'error',
        'No se pudieron cargar los artículos. Por favor, inténtelo de nuevo.'
      );
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (
      valueFilter === null ||
      valueFilter === undefined ||
      valueFilter === '' ||
      valueFilter === 0
    ) {
      this.filtersArticle = this.filtersArticle.filter(
        (f) => f.propertyName !== propertyName
      );
    } else {
      const existingFilter = this.filtersArticle.find(
        (f) => f.propertyName === propertyName
      );
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter(
      (value, index, self) =>
        index ===
        self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send() {
    this.formDevolutionDetail.enable();
    this.formDevolutionDetail.controls['devolutionId'].patchValue(
      this.devolutionModel.devolutionId
    );
    this.formDevolutionDetail.controls['articleId'].patchValue(this.articleId);
    if (this.devolutionModel.isPredevolution) {
      this.formDevolutionDetail.controls['replacementUnitValue'].patchValue(0);
    }
    Object.keys(this.formDevolutionDetail.controls).forEach((key) => {
      const control = this.formDevolutionDetail.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      } this.updateStateForm();
    });

    if (this.formDevolutionDetail.valid) {
      const modelDevolutionDetail = this.formDevolutionDetail.value as DevolutionDetailModel;

      if (this.devolutionModel.isPredevolution) {
        if (modelDevolutionDetail.predevolutionQuantity === 0) {
          this.toastHandlerService.showToast(
            'warning',
            'La cantidad de predevolución no puede ser cero.'
          );
          return;
        }
        try {
          const rentalStock = new RentalStockModalModel();
          rentalStock.articleId = modelDevolutionDetail.articleId;
          rentalStock.storeId = modelDevolutionDetail.storeId;
          rentalStock.predevolutionQuantity = modelDevolutionDetail.predevolutionQuantity;
          rentalStock.update = true;
          await firstValueFrom(this.devolutionDetailService.savePredevolutionDetails(rentalStock, this.devolutionModel.devolutionId));
          this.getArticlesForDevolutionDetail();
          this.updateListDetail.emit(true);
          let text;
          if (this.devolutionDetailContract.devolutionDetailId === 0)
            text = 'El detalle de la predevolución fue creado exitosamente.';
          else
            text = 'El detalle de la predevolución fue modificado exitosamente.';
          this.toastHandlerService.showToast('success', text);
          this.clearForm();
        } catch (error) {
          console.error('Error to update predevolution detail.', error);
        }
      } else {
        if (modelDevolutionDetail.quantity === 0 && modelDevolutionDetail.cleaningQuantity === 0 && modelDevolutionDetail.repairQuantity === 0 &&
          modelDevolutionDetail.replacementQuantity === 0) {
          this.toastHandlerService.showToast('warning', 'Las cantidades no pueden ser cero.');
          return;
        }

        if (this.devolutionDetailId === 0) {
          try {
            await firstValueFrom(this.devolutionDetailService.createDevolutionDetail(modelDevolutionDetail));
            this.getArticlesForDevolutionDetail();
            this.updateListDetail.emit(true);
            this.toastHandlerService.showToast('success', 'El detalle de la devolución fue creado exitosamente.');
            await this.areThereBalancesInCostCenter();
            this.clearForm();
          } catch (error) {
            console.error('Error to create devolution detail.', error);
          }
        } else {
          this.devolutionDetailContract.articleId = modelDevolutionDetail.articleId;
          this.devolutionDetailContract.devolutionId = modelDevolutionDetail.devolutionId;
          this.devolutionDetailContract.storeId = modelDevolutionDetail.storeId;
          this.devolutionDetailContract.predevolutionQuantity = modelDevolutionDetail.predevolutionQuantity
          this.devolutionDetailContract.quantity = modelDevolutionDetail.quantity;
          this.devolutionDetailContract.cleaningQuantity = modelDevolutionDetail.cleaningQuantity;
          this.devolutionDetailContract.cleaningValue = modelDevolutionDetail.cleaningValue;
          this.devolutionDetailContract.repairQuantity = modelDevolutionDetail.repairQuantity;
          this.devolutionDetailContract.repairValue = modelDevolutionDetail.repairValue;
          this.devolutionDetailContract.hasRepairs = modelDevolutionDetail.hasRepairs;
          this.devolutionDetailContract.replacementQuantity = modelDevolutionDetail.replacementQuantity;
          this.devolutionDetailContract.replacementValue = modelDevolutionDetail.replacementValue;
          this.devolutionDetailContract.replacementUnitValue = modelDevolutionDetail.replacementUnitValue;

          try {
            await firstValueFrom(this.devolutionDetailService.updateDevolutionDetail(this.devolutionDetailContract));
            this.getArticlesForDevolutionDetail();
            this.updateListDetail.emit(true);
            this.toastHandlerService.showToast('success', 'El detalle de la devolución fue modificado exitosamente.');
            await this.areThereBalancesInCostCenter();
            this.clearForm();
          } catch (error) {
            console.error('Error to update devolution detail.', error);
          }
        }
      }
    } else {
      this.showValidationMessages();
      this.validateForm(this.devolutionDetailContract);
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      devolutionId: {
        required: 'El campo Devolución es obligatorio.',
        min: 'Debes seleccionar una Devolución válida.',
      },
      articleId: {
        required: 'El campo Artículo es obligatorio.',
        min: 'Debes seleccionar un Artículo válido.',
      },
      storeId: {
        required: 'El campo Bodega es obligatorio.',
        min: 'Debes seleccionar una Bodega válida.',
      },
      predevolutionQuantity: {
        required: 'El campo Q.Predev. es obligatorio.',
      },
      quantity: {
        required: 'El campo Q.Alm. es obligatorio.',
      },
      cleaningQuantity: {
        required: 'El campo Q.Limpieza es obligatorio.',
      },
      cleaningValue: {
        required: 'El campo Total Limpieza es obligatorio.',
      },
      repairQuantity: {
        required: 'El campo Q.Reparación es obligatorio.',
      },
      repairValue: {
        required: 'El campo Total Reparación es obligatorio.',
      },
      replacementQuantity: {
        required: 'El campo Q.Falt. es obligatorio.',
      },
      replacementUnitValue: {
        required: 'El campo Vr.Unit.Falt. es obligatorio.',
      },
      replacementValue: {
        required: 'El campo Tot.Falt. es obligatorio.',
        min: 'El campo Tot.Falt. no puede ser negativo.',
        max: 'El campo Tot.Falt. no puede superar 99.999.999.999,99.',
      },
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formDevolutionDetail.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: true,
      filters: this.filtersArticle,
    });
  }

  updateStateForm() {
    setTimeout(() => {
      if (this.swHabilitarLimpiezaEnDevoluciones) {
        this.formControlStateService.setControlState(this.formDevolutionDetail, ['cleaningQuantity', 'cleaningValue'], true);
      } else {
        this.formControlStateService.setControlState(this.formDevolutionDetail, ['cleaningQuantity', 'cleaningValue'], false);
      }
      this.formControlStateService.setControlState(this.formDevolutionDetail, ['hasRepairs'], false);
      if (this.devolutionDetailContract.hasRepairs) {
        this.formControlStateService.setControlState(this.formDevolutionDetail, ['repairValue'], false);
      } else {
        this.formControlStateService.setControlState(this.formDevolutionDetail, ['repairValue'], true);
      }
      if (this.devolutionModel.isPredevolution) {
        this.formControlStateService.setControlState(this.formDevolutionDetail, ['predevolutionQuantity'], true);
      } else {
        this.formControlStateService.setControlState(this.formDevolutionDetail, ['predevolutionQuantity'], false);
      }
    }, 100);
  }

  validateForm(devolutionDetail: DevolutionDetailModel) {
    this.formDevolutionDetail = this.formBuilder.group({
      devolutionId: [devolutionDetail.devolutionId, [Validators.required, Validators.min(1)]],
      articleId: [devolutionDetail.articleId, [Validators.required, Validators.min(1)]],
      storeId: [devolutionDetail.storeId, [Validators.required, Validators.min(1)]],
      predevolutionQuantity: [devolutionDetail.predevolutionQuantity],
      quantity: [devolutionDetail.quantity],
      cleaningQuantity: [devolutionDetail.cleaningQuantity],
      cleaningValue: [devolutionDetail.cleaningValue],
      repairQuantity: [devolutionDetail.repairQuantity],
      repairValue: [devolutionDetail.repairValue],
      hasRepairs: [devolutionDetail.hasRepairs],
      replacementQuantity: [devolutionDetail.replacementQuantity, [Validators.required]],
      replacementUnitValue: [(devolutionDetail.replacementValue && devolutionDetail.replacementQuantity > 0)
        ? devolutionDetail.replacementValue / devolutionDetail.replacementQuantity : 0, [Validators.required]],
      replacementValue: [devolutionDetail.replacementValue, [Validators.required, Validators.min(0), Validators.max(99999999999.99)]],
    });
    this.updateStateForm();
    this.rentalStockForm = this.rentalStockArticle;
  }

}
